/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { ChangeEvent } from 'react';
import { t } from '../../translations/i18n';
import { Input, InputAdornment } from '@mui/material';
import Close from '../../icons/Close.svg?react';
import Search from '../../icons/Search.svg?react';

const FilterInputStyle = css`
  width: 320px;
  height: 40px;
  background: #ffffff;
  border-radius: 25px;
  border: 1px solid #dbe4e9 !important;
`;

type FilterInputProps = {
  value: string;
  onChangeValue: (event: ChangeEvent<HTMLInputElement>) => void;
  onResetValue: () => void;
};

/**
 * @name FilterInput
 * @param props
 * @summary Controlled input for handling filters and search operations
 *
 */
const MmgFilterInput = (props: FilterInputProps) => {
  const { value, onChangeValue, onResetValue } = props;
  return (
    <Input
      type="input"
      autoFocus
      onChange={onChangeValue}
      css={FilterInputStyle}
      disableUnderline={true}
      placeholder={t('PROJECTS_FILTER_PLACEHOLDER')}
      value={value}
      startAdornment={
        <InputAdornment position="start">
          <Search />
        </InputAdornment>
      }
      endAdornment={
        value !== '' ? (
          <InputAdornment position="end" onClick={onResetValue}>
            <Close />
          </InputAdornment>
        ) : null
      }
    />
  );
};

export default MmgFilterInput;
